import React from 'react'
import classNames from 'classnames'
import styles from './InputWrapper.module.css'
import { default as generalStyle } from '../Theme/GeneralTheme.module.css'

function InputWrapper({
  children,
  iconLeft = false,
  iconRight = false,
  valid = false,
  invalid = false,
  alert = false,
  onClickIconRight,
  onClickIconLeft,
  ...props
}) {

  const { className, ...rest } = props;
  const childrenClassNames = classNames([
    generalStyle.general_style,
    styles.inputwrapper,
    valid && styles.valid,
    invalid && styles.invalid,
    alert && styles.alert,
  ], className)

  return (
    <div
      className={childrenClassNames}
      {...rest}
    >
      {iconLeft && (
        <span
          onClick={onClickIconLeft}
          className={classNames([iconLeft && styles.icon_inside_left])}
        >
          {iconLeft}
        </span>
      )}
      {iconRight && (
        <span
          onClick={onClickIconRight}
          className={classNames([iconRight && styles.icon_inside_right])}
        >
          {iconRight}
        </span>
      )}
      {children}
    </div>
  )
}

function InputIconInside({
  children,
  iconLeft,
  iconRight,
  iconRightOnAction = false,
  expandable,
  withoutMargin = false,
  ...props
}) {

  const { className, ...rest } = props;
  const childrenClassNames = classNames([
    styles.inputiconinside,
    expandable && styles.expandable_events_pointer,
  ], className)

  return (
    <div
      className={childrenClassNames}
      onClick={props.onClick}
      {...rest}
    >
      {children}
      {iconLeft && (
        <span
          className={classNames([
            iconLeft && styles.icon_inside_left,
            withoutMargin && styles.without_margin,
          ])}
        >
          {iconLeft}
        </span>
      )}
      {iconRight && (
        <span
          className={classNames([
            iconRight && styles.icon_inside_right,
            iconRightOnAction && styles.icon_inside_right_action,
            withoutMargin && styles.without_margin,
          ])}
        >
          {iconRight}
        </span>
      )}
    </div>
  )
}

export { InputWrapper, InputIconInside }
